export const GIFT_CARD_SKU = 'giftcard';

export function giftAmountCents(value) {
  const match = String(value ?? '').trim().match(/^(\d+)(?:[.,](\d{1,2}))?$/);
  if (!match) return null;
  const cents = Number(match[1]) * 100 + Number((match[2] || '').padEnd(2, '0'));
  return Number.isSafeInteger(cents) && cents > 0 ? cents : null;
}

export function isGiftCardProduct(product) {
  return [product?.sku, product?.productSku, product?.id]
    .some(value => String(value || '').trim().toLowerCase() === GIFT_CARD_SKU);
}

export function isGiftCardOrder(order) {
  return Array.isArray(order?.products) && order.products.length > 0
    && order.products.every(isGiftCardProduct);
}

const giftOrderDateFormatter = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Europe/Rome', year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23',
});

export function resolveGiftCardOrderDate(order) {
  if (order?.gift?.type !== 'giftcard' || !isGiftCardOrder(order)) return order?.orderDate;

  // Early gift orders dropped the timezone from their UTC orderDate. Rebuild
  // the Rome wall-clock value from the original instant, never by adding hours.
  for (const value of [order.createdAt, order.gift.createdAt]) {
    if (typeof value !== 'string' || !/T.*(?:Z|[+-]\d{2}:\d{2})$/i.test(value)) continue;
    const date = new Date(value);
    if (!Number.isFinite(date.getTime())) continue;
    const parts = Object.fromEntries(giftOrderDateFormatter.formatToParts(date)
      .filter(part => part.type !== 'literal').map(part => [part.type, part.value]));
    return `${parts.year}-${parts.month}-${parts.day} ${parts.hour}:${parts.minute}:${parts.second}`;
  }
  return order.orderDate;
}
